import Image from '@components/ui/image'
import { urlFor } from '@lib/sanity/url-for'
import { motion, MotionValue, useTransform } from 'framer-motion'
import { cx } from '@linaria/core'
import React, { FC } from 'react'
import { SanityAsset } from 'sanity-codegen'
import * as styles from './styles'

type LayerProps = {
  scrollY: MotionValue<number>
  windowHeight: number
  windowWidth: number
  source: SanityAsset
  index: number
}

export const Layer: FC<LayerProps> = ({ scrollY, windowHeight, windowWidth, index, source }) => {
  const transformDistance = windowWidth > 1024 ? windowWidth / 55 : windowWidth > 767 ? 20 : 8
  const transformDistancePeter = windowWidth > 1024 ? windowWidth / 35 : windowWidth > 767 ? 30 : 16
  const transform = useTransform(
    scrollY,
    [windowHeight * 0.1, windowHeight * 0.3, windowHeight * 2],
    [
      'translate3d(0px, 0px, 0px)',
      `translate3d(${transformDistance * index}px, -${transformDistance * index}px, 0px)`,
      `translate3d(${transformDistancePeter * index}px, -${transformDistancePeter * index}px, 0px)`,
    ]
  )
  return (
    <motion.div className={cx(styles.layer, index === 0 && styles.first)} style={{ transform }}>
      <Image
        ratio={[0.62]}
        placeholderSrc={urlFor(source).width(20).url()}
        sources={[
          urlFor(source).width(700).url(),
          urlFor(source).width(1024).url(),
          urlFor(source).width(1800).url(),
        ]}
        alt=""
      />
    </motion.div>
  )
}
